import React from 'react';
import ReactDOM from 'react-dom/client';

import { AppContextProvider } from './store/app-context';
import { AuthContextProvider } from './store/auth-context';
import { ReaderContextProvider } from './store/reader-context';

import './index.scss';
import App from './components/App';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AppContextProvider>
      <AuthContextProvider>
        <ReaderContextProvider>
          <App />
        </ReaderContextProvider>
      </AuthContextProvider>
    </AppContextProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
